import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-notifications-page-ui',
    templateUrl: './bb-notifications-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class NotificationsPageComponent {}
